import { useRef } from 'react';
import { hideMenu } from 'react-contextmenu';

export const useHoverClose = (delay = 1000) => {
  const hoverTimeout = useRef<ReturnType<typeof setTimeout>>();

  const onEnter = () => {
    if (hoverTimeout.current) clearTimeout(hoverTimeout.current);
  };
  const onLeave = () => {
    hoverTimeout.current = setTimeout(() => hideMenu(), delay);
  };
  const onShow = () => onEnter();

  return { onEnter, onLeave, onShow };
};
